import { api } from '@/shared/lib/axios';

// `/api/gems` endpoints. Response shapes mirror api/'s `GemController` +
// `PublicGem` (gem.service.ts) — hand-typed (no codegen), per the project's
// "types near the consumer" convention.

export interface LocalizedText {
  en: string;
  ar: string;
}

export interface LocalizedNullableText {
  en: string | null;
  ar: string | null;
}

export type GemVisibility = 'public' | 'authenticated';

export interface Gem {
  id: string;
  slug: string;
  name: LocalizedText;
  description: LocalizedNullableText;
  icon: string | null;
  /** Badge accent color (hex) — always present; backend derives it when unset. */
  accent: string;
  visibility: GemVisibility;
  sortOrder: number;
}

interface ListGemsResponse {
  data: Gem[];
}

// Lists the gems available to the caller. The endpoint is visibility-filtered
// server-side by auth state, so this only ever returns gems the user may use.
export async function listGems(): Promise<Gem[]> {
  const res = await api.get<ListGemsResponse>('/api/gems');
  return res.data.data;
}
